import { gql } from '@apollo/client';

export const FETCH_FACILITY_LOCATIONS_VIA_MONITORS = gql`
    query FetchFacilityLocationsViaMonitors($companyFilter: CompanyFilter) {
        system {
            companies(filter: $companyFilter) {
                alias
                facilities {
                    alias
                    processes {
                        ... on Monitor {
                            location {
                                latitude
                                longitude
                            }
                            isVisible
                        }
                    }
                }
            }
        }
    }
`;
